import AxiosInstance from "./api";

export const FixedAssetsRegisterService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/fixed-assets-registers/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/fixed-assets-registers/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/fixed-assets-registers", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/fixed-assets-registers/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/fixed-assets-registers/" + id);
  },
};
